<template>
  <article></article>
</template>

<script>
import { mapGetters } from "vuex"

export default {
  name: "GetToken",
  mounted() {
  },
  methods: {
    ...mapGetters(["getRedirectUrl"]),
  },
}
</script>

<style scoped></style>
